// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

export enum SDPCandidateType {
  Host = 'host',
  ServerReflexive = 'srflx',
  PeerReflexive = 'prflx',
  Relay = 'relay',
}

export default SDPCandidateType;
